var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "health-cross"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.25 21H9.75C9.35232 20.9995 8.97105 20.8414 8.68984 20.5602C8.40864 20.2789 8.25046 19.8977 8.25 19.5V15.75H4.5C4.10232 15.7495 3.72105 15.5914 3.43984 15.3102C3.15864 15.029 3.00046 14.6477 3 14.25V9.75C3.0004 9.3523 3.15856 8.971 3.43978 8.68978C3.721 8.40856 4.1023 8.2504 4.5 8.25H8.25V4.5C8.2504 4.1023 8.40856 3.721 8.68978 3.43978C8.971 3.15856 9.3523 3.0004 9.75 3H14.25C14.6477 3.00046 15.029 3.15864 15.3102 3.43984C15.5914 3.72105 15.7495 4.10232 15.75 4.5V8.25H19.5C19.8977 8.25046 20.2789 8.40864 20.5602 8.68984C20.8414 8.97105 20.9995 9.35232 21 9.75V14.25C20.9995 14.6477 20.8413 15.0289 20.5601 15.3101C20.2789 15.5913 19.8977 15.7495 19.5 15.75H15.75V19.5C15.7495 19.8977 15.5913 20.2789 15.3101 20.5601C15.0289 20.8413 14.6477 20.9995 14.25 21ZM4.5 9.75V14.25H9.75V19.5H14.25V14.25H19.5V9.75H14.25V4.5H9.75V9.75H4.5Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthCross);
export default __webpack_public_path__ + "static/media/health-cross.aa994897e85fbfe6cca7adec848b6450.svg";
export { ForwardRef as ReactComponent };